/**
 * Created by forbiz on 2019-02-11.
 */
import Swiper from 'swiper/dist/js/swiper'

const layout = () => {
    const $window = $(window);
    const $htmlbody = $('html, body');

    const btnTop = () => {
        const $top = $('.hd__top, .hd__value');

        $window.on('load scroll', function() {
            if ( $window.scrollTop() > 0 ) $top.addClass('show');
            else $top.removeClass('show');
        });

        $htmlbody
            .on('click', '.hd__top', function(e) {
                $htmlbody.animate({'scrollTop': 0});

                e.preventDefault();
            });
    };

    const headerEvent = () => {
        const $header = $('.header');
        const $inner = $('.header__inner');
        let flag = false;

        const headerColor = ( st ) => {
            const _header_val = st * 0.004;

            if ( st == 0 ) {
                $header.css({
                    'backgroundColor': '',
                    'boxShadow' : ''
                });
            } 
        };

        const headerScroll = () => {
                
            $window.on('load scroll', function() {
                const $bannerHeight = $('.topBanner').css('display') == 'block' ? $('.topBanner').outerHeight(true) : 0;
                
                if ( $window.scrollTop() >= $bannerHeight + $('.user-area').outerHeight(true) + 62 ) {
                    $('.header').addClass('fixed');
                } else {
                    $('.header').removeClass('fixed');
                }

                if ( !flag ) {
                    if ( $('#main').length > 0 || $('#healthCare').length > 0 ) {
                        headerColor( $window.scrollTop() );
                    }
                }
                
                if ( !$('.header').hasClass('fixed') ) {
                    $('.popup_search .hd__popup__modal').stop().animate({'top': 160 + $bannerHeight});
                } else {
                    $('.popup_search .hd__popup__modal').stop().animate({'top': 60});
                }
            });
        };

        const headerMouse = () => {
            $inner.on('mouseenter', function(e) {
                $header.css({
                    'backgroundColor': '#FFF',
                    'boxShadow' : '0px 20px 20px -20px rgba(0, 0, 0, 0.1)'
                });

                flag = true;

                e.preventDefault();
            });
        };

        const headerEventInit = () => {
            headerScroll();
            if ( $('#main').length > 0 || $('#healthCare').length > 0 ) headerMouse();
        };

        headerEventInit();
    };

    const windowPopup = () => {
        const $winOpen = $('#footer .winOpen');
        const $close = $('.window-popup .btn__close');

        $winOpen
            .on('click', function(e) {
                const $this = $(this);
                const _url = $this.data('url');
                const options = 'left=0, top=0, width=800, height=1200, resizeble=no, scrollbars=yes, status=no';
                window.open(_url, '_blank', options);

                e.preventDefault();
            });

        $close
            .on('click', function(e) {
                window.close();

                e.preventDefault();
            });
    };

    const moreSiteMap = () => {
        const $sitemap = $('.familySite');
        const $btn = $('.familySite__default');
        const $inner = $('.familySite__inner');

        $btn.on('click', function(e) {
            const $this  = $(this);

            if ( !$this.hasClass('on') ) {
                $this.addClass('on').next($inner).stop().slideDown();
                $inner.scrollTop(0);
            } else {
                $this.removeClass('on').next($inner).stop().slideUp();
            }
            

            e.preventDefault();
        });

        $sitemap.on('mouseleave', function() {
            const $this = $(this);

            $this.find($btn).removeClass('on');
            $this.find($inner).stop().slideUp();
        });
    };

    const searchFocus = () => {
        $(document)
            .on('focus', ".direct__search .search-input", function () {
                const $this = $(this);
                $this.attr('placeholder', '검색어를 입력해 주세요.');
            })

            .on('blur', ".direct__search .search-input", function () {
                const $this = $(this);
                $this.attr('placeholder', "그리팅 '기프트 카드' 출시!");

            });
    };

    const gnbSwiper = () => {
        var totalWidth = 0;

        $('.gnb .swiper-container .gnb__list').each(function(){
            totalWidth = totalWidth + $(this).outerWidth();
        });

        if( totalWidth >= '539' ){
            hdFn.hdSlide('.gnb .swiper-container .swiper-wrapper', {
                infinite: false,
                arrows: false,
                variableWidth: true
            });
        }
    };

    const layoutInner = () => {
        btnTop();
        headerEvent();
        windowPopup();
        moreSiteMap();
        searchFocus();
        gnbSwiper();
    };

    layoutInner();
};

export default layout;